import React from 'react';
import AvertleGame from './avertle';

function App() {
  return <AvertleGame />;
}

export default App;